export const initAnimation = () => {
	// 監視対象の要素をすべて取得
	const targets = document.querySelectorAll(".js-scrolled");

	// オプション設定
	const options = {
		root: null, // ビューポートを基準
		rootMargin: "0px 0px -100px 0px", // 画面の下から100px入ったところで発火
		threshold: 0, // 少しでも入ったら反応
	};
	// 交差した時の処理
	const observer = new IntersectionObserver((entries, obs) => {
		entries.forEach((entry) => {
			// 画面に入ったら
			if (entry.isIntersecting) {
				entry.target.classList.add("is-action");

				// 一度表示したら監視をやめる（パフォーマンス向上 ＆ 何度もアニメさせない）
				obs.unobserve(entry.target);
			}
		});
	}, options);

	// 各要素を監視リストに追加
	targets.forEach((target) => {
		observer.observe(target);
	});
};
